import { Paragraph, Space, Text } from '@/components/atoms';
import moment from 'moment';
import logo from '@images/common/logo-pincar-white.png';
import { Link } from 'react-router-dom';
import { PATH_TERMS_OF_PRIVACY, PATH_TERMS_OF_SERVICE } from '@/constants/constant';

type FooterProps = {
  // TODO
};

const Footer = (props: FooterProps) => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <img className="logo" src={logo} alt="footer logo" />
        <Space direction="horizontal" className="link">
          <a className="link-list first" href="https://transfer.pincar.co.kr">
            회사소개
          </a>
          <a className="link-list" href="mailto:support@pincar.co.kr">
            대표 이메일
          </a>
          {/* <a */}
          {/*  className="link-list" */}
          {/*  onClick={() => { */}
          {/*    message.warning('준비중인 기능입니다.'); */}
          {/*  }} */}
          {/* > */}
          {/*  고객센터 */}
          {/* </a> */}
          {/* <a */}
          {/*  className="link-list" */}
          {/*  onClick={() => { */}
          {/*    message.warning('준비중인 기능입니다.'); */}
          {/*  }} */}
          {/* > */}
          {/*  원격 지원 서비스 */}
          {/* </a> */}
        </Space>
        <Text className="information">
          <Paragraph>
            © 2014-{moment().year()} (주)핀카 | 경기도 용인시 처인구 성산로 121번길 24, A동(역북동) |{' '}
            <Link to={PATH_TERMS_OF_PRIVACY}>개인정보처리방침</Link> | <Link to={PATH_TERMS_OF_SERVICE}>이용약관</Link>
          </Paragraph>
          <Paragraph>대표자: 안남훈, 장영수 | 사업자등록번호: 107-88-29970 | 대표전화: 031-338-5101</Paragraph>
        </Text>
      </div>
    </footer>
  );
};

Footer.defaultProps = {
  // TODO
};

export default Footer;
